import "../GlobalStyles.css";
import { Button, ButtonGroup} from "reactstrap";
import { useHistory } from "react-router";
import UserHeaderComponent from "../UserHeaderComponent";
import { Link } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import { css } from "@emotion/react";
import { useMsal } from "@azure/msal-react";
import DriverService from "../../Services/DriverService"; 
import EmployeeService from "../../Services/EmployeeService"; 
import Charge from "../../Models/Charge";
import UserChargesForm from "./UserChargesForm";
import MoonLoader from "react-spinners/MoonLoader";
import "./Charges.css"

import { FileText } from 'react-bootstrap-icons';

export default function UserChargesPage(props: any){

    const history = useHistory();
    const {instance} = useMsal();
    const employeeService = useMemo(() => new EmployeeService(instance), [instance]);
    const driverService = useMemo(() => new DriverService(instance), [instance]);
    

    const [charges, setCharges] = useState<Charge[]>([])
    const [isLoading, setIsLoading] = useState(false);
    const [filteredCharges, setFilteredCharges] = useState<Charge[]>([]);
    
    const [selectedMonth, setSelectedMonth] = useState<number>(new Date().getMonth() + 1)
    const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear())

   useEffect(() =>{
        async function getCharges(){
            try {
                setIsLoading(true)
                await fetchUserCharges();

                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching user charges data: ", error)
                setIsLoading(false);
            }
        }
        getCharges();
        
   },[])

   useEffect(() => {
    filterCharges();
    },[selectedMonth, selectedYear, charges])

   
    async function fetchUserCharges(){
        try {

            const employee = await employeeService.getEmployeeByUserName();
            if(!employee){
                throw new Error(`Kan geen medewerker vinden.`)
            }
            let charges: Charge[] = await driverService.GetChargesByEmployeeContactId(employee.contactId);
           
            charges.sort((a, b) => new Date(a.chargeDate).getTime() - new Date(b.chargeDate).getTime());
            charges.reverse();

            setCharges(charges);

        } catch (error) {
             console.error("Error met laadbeurten data te fetchen");
             //goBackToOverViewApp();
        }
    }


   const filterCharges = () => {
    const filtered = charges.filter(charge => {
        const chargeDate = new Date(charge.chargeDate);
        const chargeMonth = chargeDate.getMonth() + 1;
        const chargeYear = chargeDate.getFullYear();
        
        if (selectedMonth === 0 && selectedYear === 0) {
            return true;
        }
        if (selectedMonth === 0) {
            return chargeYear === selectedYear;
        } 
        if (selectedYear === 0) {
            return chargeMonth === selectedMonth;
        }
        return chargeMonth === selectedMonth && chargeYear === selectedYear;
    });
    
    setFilteredCharges(filtered);
};

const deleteChargeById = (chargeId: string) => {
    const updatedChargesArray = charges.filter((charge) => charge.chargeId !== chargeId);
    setCharges(updatedChargesArray);
};
const handleMonthChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedMonth(parseInt(event.target.value))
}
const handleYearChange = (event: React.ChangeEvent<HTMLSelectElement>) =>{
    setSelectedYear(parseInt(event.target.value))
}

const monthOptions = Array.from({length: 12}, (_,index) => {
    const month = index + 1;
    return (
        <option key={month} value={month}>
                {new Date(selectedYear, month - 1, 1).toLocaleString('default', {month:'long'})}
        </option>
    )
});

const yearOptions = Array.from({length: 10}, (_,index) => {
    const year = new Date().getFullYear() - 2 + index;
    return (
        <option key={year} value={year}>
            {year}
        </option>
    )
})


    function GetUI(){

        return (
            <>
             {isLoading === false && (
                    <div className="top-section">
                        <div>
                    <select value={selectedMonth} onChange={handleMonthChange}>
                        <option value={0}>Elke maand</option>
                        {monthOptions}
                    </select>
                    <select value={selectedYear} onChange={handleYearChange}>
                        <option value={0}>Elk jaar</option>
                        {yearOptions}
                    </select>
                        </div>
            
                   
                        <Link to="/user-charges-registration">
                        <Button color="primary" className="mb-3 mr-1 p-2 pl-3 pr-3 mt-3 register-button rounded-lg">
                                <i className="fas fa-plus fa-md plus-button"></i>
                        </Button>
                        </Link>
                    
                    </div>)}

            {selectedMonth === 0 && selectedYear === 0 ?  
            <UserChargesForm chargesArray={charges} setIsLoading={setIsLoading} isLoading={isLoading} deleteChargeById={deleteChargeById}/> 
            : 
            <UserChargesForm chargesArray={filteredCharges} setIsLoading={setIsLoading} isLoading={isLoading} deleteChargeById={deleteChargeById}/>}
        </>
        )
    }

    function getButtonDiv() {
        return (
            <>
                <ButtonGroup className="fixed-bottom navbar p-0">
                    <Button className="p-3 buttons-footer" style={{ backgroundColor: "#2F5FA1" }} onClick={() => history.push("/overview-user")}>
                        <i className="fas fa-arrow-left fa-2x"></i>
                    </Button>
                    <Button className="p-3 buttons-footer" style={{ backgroundColor: "#2F5FA1" }} onClick={() => history.push("/overview")}>
                        <i className="fas fa-home fa-2x"></i>
                    </Button>
                    <Button className="p-3 buttons-footer" style={{ backgroundColor: "#2F5FA1" }} onClick={() => history.push("/user-charges-payout")}>
                        <FileText fontSize={34}/>
                    </Button>
                </ButtonGroup>
            </>
        );
    }

    function getLoadSpinner() {
        return (
            <MoonLoader
                color="black"
                loading={isLoading}
                css={
                    css`
                    display: block;
                    position: absolute;
                    left: calc(50% - 18px);
                    top: 125px; 
                    z-index: 1000`
                }
                size={25} />
        );
    }


    return (
        <>
            {getLoadSpinner()}
            <UserHeaderComponent headerText={"Gegevens laadbeurten"} />
        
                {GetUI()}
            
            {getButtonDiv()}

        </>
    )
}







